import React, {useCallback, useEffect} from "react";
import {Badge, Button, ToggleButtonGroup} from "react-bootstrap";
import PropTypes from "prop-types";

const normalizeCount = (value) => {
  if (typeof value === "number" && Number.isFinite(value)) {
    return value;
  }

  if (typeof value === "string") {
    const parsed = Number(value.replaceAll(",", ""));
    if (Number.isFinite(parsed)) {
      return parsed;
    }
  }

  return 0;
};

const formatCount = (value) => {
  if (value === null || value === undefined || value === "") {
    return "";
  }

  return normalizeCount(value).toLocaleString();
};

export const WorklistQuickfilter = ({ activeFilterView, setActiveFilterView, nowTotalSize, soonTotalSize, priorityTotalSize, priorityScreeningsEnabled, setPageNumber, resetDefault, loading }) => {
  const priorityCount = normalizeCount(priorityTotalSize);

  const onFilterButtonClickHandler = useCallback(( filterType, isActive) => {
    if (isActive) {
      setActiveFilterView('RECOMMENDED_NOW');
      setPageNumber(1);
    }
    else {
      switch (filterType) {
        case 'rn':
          setActiveFilterView('RECOMMENDED_NOW');
          setPageNumber(1);
          break;
        case 'rs':
          setActiveFilterView('RECOMMENDED_SOON');
          setPageNumber(1);
          break;
        case 'pa':
          setActiveFilterView('PRIORITY_ACTIVITY');
          setPageNumber(1);
          break;
        default:
          break;
      }
    }
     
  }, [setActiveFilterView, setPageNumber]);

  useEffect(() => {
    if (resetDefault) {
      onFilterButtonClickHandler('rn', false);
    }
  }, [onFilterButtonClickHandler, resetDefault]);

  useEffect(() => {
    if (activeFilterView === "PRIORITY_ACTIVITY" && (!priorityScreeningsEnabled || priorityCount <= 0)) {
      setActiveFilterView("RECOMMENDED_NOW");
      setPageNumber(1);
    }
  }, [activeFilterView, priorityScreeningsEnabled, priorityCount, setActiveFilterView, setPageNumber]);

  return (
    <ToggleButtonGroup type="radio" className="workListFilters gap-2" name="workListFilters">
      {priorityScreeningsEnabled && priorityCount > 0 &&
        <Button disabled={loading} id="PRIORITY_ACTIVITY" variant="light" className={`border p-3 text-start text-dark ${activeFilterView === 'PRIORITY_ACTIVITY' ? 'active' : ''}`}
          onClick={() => { onFilterButtonClickHandler('pa', activeFilterView === 'PRIORITY_ACTIVITY'); }} value="PRIORITY_ACTIVITY">
          <div className="d-flex justify-content-between align-items-center mb-3">
            <i className="fa-regular fa-circle-exclamation fa-lg text-primary"></i>
            <Badge pill bg="primary">{formatCount(priorityTotalSize)}</Badge>
          </div>
          <b className="fs-4 mb-3">Priority 2025 Screenings</b>
          <p className="mb-0">Patients with care opportunities that are critical to complete before year-end</p>
        </Button>
      }
      <Button disabled={loading} id="RECOMMENDED_NOW" variant="danger" className={`p-3 text-start text-dark rounded ${activeFilterView === 'RECOMMENDED_NOW' ? 'active' : ''}`}
        onClick={(e) => { onFilterButtonClickHandler('rn', activeFilterView === 'RECOMMENDED_NOW'); }} value="RECOMMENDED_NOW">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <i className="fa-regular fa-clock fa-lg text-danger"></i>
          <Badge pill bg="danger">{formatCount(nowTotalSize)}</Badge>
        </div>
        <b className="fs-4 mb-3">Recommended Now</b>
        <p className="mb-0">Patients needing timely visit or screening follow-up</p>
      </Button>
      <Button disabled={loading} id="RECOMMENDED_SOON" variant="primary" className={`border p-3 text-start text-dark ${activeFilterView === 'RECOMMENDED_SOON' ? 'active' : ''}`}
        onClick={() => { onFilterButtonClickHandler('rs', activeFilterView === 'RECOMMENDED_SOON'); }} value="RECOMMENDED_SOON">
        <div className="d-flex justify-content-between align-items-center mb-3">
          <i className="fa-regular fa-calendar fa-lg text-primary"></i>
          <Badge pill bg="primary">{formatCount(soonTotalSize)}</Badge>
        </div>
        <b className="fs-4 mb-3">Recommended Soon</b>
        <p className="mb-0">Patients with upcoming visit or screening needs</p>
      </Button>
    </ToggleButtonGroup>
  );
};

WorklistQuickfilter.propTypes = {
  activeFilterView: PropTypes.string,
  setActiveFilterView: PropTypes.func.isRequired,
  nowTotalSize: PropTypes.number,
  soonTotalSize: PropTypes.number,
  priorityTotalSize: PropTypes.number,
  priorityScreeningsEnabled: PropTypes.bool,
  setPageNumber: PropTypes.func.isRequired,
  resetDefault: PropTypes.bool,
  loading: PropTypes.bool,
};

export default WorklistQuickfilter;
